// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__1u-sB","icon":"SearchBar_icon__2ueOw"};